import { Tooltip as TooltipAntd } from 'antd';
import './Tooltip.scss';

const Tooltip = ({ children, title, getPopupContainer, ...props }) => {
  return (
    <TooltipAntd
      {...props}
      title={title}
      // Render tooltip vào body thay vì parent
      getPopupContainer={getPopupContainer || (() => document.body)}
    >
      {children}
    </TooltipAntd>
  );
};

export default Tooltip;
